// Convex HTTP API utility
// You should set your Convex deployment URL as an environment variable
const CONVEX_URL = import.meta.env.VITE_CONVEX_URL || 'https://proper-horse-117.convex.cloud';

/**
 * Makes an HTTP request to a Convex query function
 * @param {string} functionPath - The path to the Convex function (e.g., 'functions/user/search:searchProfiles')
 * @param {object} args - The arguments to pass to the function
 * @returns {Promise<any>} - The result from the Convex function
 */
export async function convexQuery(functionPath, args = {}) {
  try {
    const url = `${CONVEX_URL}/api/query`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        path: functionPath,
        args: args,
        format: 'json',
      }),
    });

    console.log(response)

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      console.error('Convex error:', errorData);
      throw new Error(errorData.message || `Convex request failed: ${response.statusText}`);
    }

    const data = await response.json();
    console.log(data)
    return data.value;
  } catch (error) {
    console.error('Convex query error:', error);
    throw error;
  }
}

